<template>
    <div class="publication__search content-width" ref="search">

        <div class="publication__search-selected d-flex" v-if="selectedCity.name">
            <div class="publication__search-selected-item d-flex">
                <div class="publication__search-selected-name">{{selectedCity.name}}</div>
                <span @click.prevent="setCity({name: null, id: null})">
                        <img src="/assets/images/icons/publication-close.svg" alt="">
                </span>
            </div>
        </div>

        <div class="publication__search-wrapper">

            <div class="text-danger" v-if="$v.city_id.$error">{{$store.getters.t('homestays_store_form_choose_city')}}</div>

            <div class="publication__search-input" :class="{'publication__search-input--active': search}">
                <input type="text" :value="search" @input="search = $event.target.value"
                       :placeholder="$store.getters.t('homestay_start_typing_locality')">
            </div>
            <div class="publication__search-list" v-if="search" ref="searchList">
                <template v-if="cities.length">
                    <div class="publication__search-item" @click.prevent="setCity(item)" v-for="item in cities" >{{ item.name }}</div>
                </template>
                <template v-if="!cities.length && search && search !== selectedCity.name">
                    <div class="publication__search-empty">{{$store.getters.t('homestays_store_form_nothing_found')}}</div>
                </template>
            </div>

        </div>

    </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "SelectLocation",
    props: ['server'],
    mixins: [StateMixin],
    data(){
        return{
            search: null,
            cities: [],
        }
    },

    computed: {

        selectedCity: {
            get(){ return this.GET_BY_KEY('selectedCity') },
            set( val ) {
                this.SET_PET_BY_KEY({ key: 'selectedCity', data: val })
            }
        },

        city_id: {
            get(){ return this.GET_BY_KEY('city_id') },
            set( val ) {
                this.SET_PET_BY_KEY({ key: 'city_id', data: val })
            }
        }

    },

    watch: {
        search( val ){

            if( ! val ) {

                this.handleHeight()

                this.selectedCity = { name: null, id: null };
                this.city_id = null;
                this.cities = [];
                return;
            }

            if( val !== this.selectedCity.name ){
               this.searchMethod();
            }

        }

    },

    mounted(){

        if( this.selectedCity.name ) {
            this.search = this.selectedCity.name
        }

    },

    methods: {

        async searchMethod() {

            try{

                const { data: { cities = [], success = false } } = await axios.get( '/geo/searchCities', { params: { searchValue: this.search } });

                if( success ){

                    new Promise( res => {
                        this.cities = cities;
                        res();
                    } ).then( () => {
                        this.handleHeight()
                    } )

                }

            } catch ( _e ){

                console.log( _e );

            }

        },

        handleHeight(){
            this.$parent.handleSliderHeight()
        },

        setCity( _target ){

            new Promise( res => {
                this.search = _target.name;
                this.selectedCity = _target;
                this.city_id = _target.id;
                this.cities = [];
                res()
            } ).then(() => { this.handleHeight() })

        },

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true
        }


    },

    validations: { city_id: { required } }

}
</script>

<style scoped>

</style>
